export default __webpack_public_path__ + "static/media/tiger_NORMAL.b159d2ee.png";